import { getBusinessDocumentationPreSignedURL, uploadBusinessDocumentationDocumentToS3 } from '../api/documents.api'

type JoinedData = {
  _id: string
  [key: string]: any
}

type PocketData = {
  _id: string
  name: string
  [key: string]: any
}

type Item = {
  _id: string
  consecutiveNumber: number
  joinedData?: JoinedData[]
  pocketData?: PocketData
  [key: string]: any
}

export type TablePayment = {
  _id: string
  status: string
  amount: string
  createdAt: string
  belongsTo: string
  customerId: string
  documentId: string
  referenceNumber: string
  description?: string
  paidAt: string
  [key: string]: any
}

export const uploadBusinessDocumentationFile = async (businessDocumentFileToUpload: File, businessDocumentFileToUploadSystemName: string, accessTokenData: string) => {
  try {
    const businessDocumentFileToUploadAsBlob = businessDocumentFileToUpload.slice(0, businessDocumentFileToUpload.size)
    const businessDocumentFileToUploadRenamed = new File([businessDocumentFileToUploadAsBlob], businessDocumentFileToUploadSystemName, { type: `${businessDocumentFileToUpload.type}` })

    const businessDocumentationFileData = {
      businessDocumentationFileType: businessDocumentFileToUpload.type,
      businessDocumentationFileSystemName: businessDocumentFileToUploadSystemName
    }

    const businessDocumentFileToUploadPreSignedURL = await getBusinessDocumentationPreSignedURL(businessDocumentationFileData, accessTokenData)
    await uploadBusinessDocumentationDocumentToS3(businessDocumentFileToUploadPreSignedURL.data, businessDocumentFileToUpload.type, businessDocumentFileToUploadRenamed)

    return true
  } catch (error) {
    console.log('Error uploadBusinessDocumentationFile > ', String(error))
    throw new Error(`Error uploadBusinessDocumentationFile > ${String(error)}`)
  }
}

export const mergeAndSortByConsecutiveNumber = (firstArray: Array<Item>, secondArray: Array<any>): Array<Item> => {
  const existingIds = new Set(secondArray.map((item) => item._id))
  const newItems = firstArray.filter((item) => !existingIds.has(item._id))
  const merged = [...secondArray, ...newItems]

  return merged.sort((a, b) => b.consecutiveNumber - a.consecutiveNumber)
}

export const mergeAndSortPayments = (basePayments: Array<TablePayment>, incomingPayments: Array<TablePayment>): Array<TablePayment> => {
  const existingIds = new Set<string>(basePayments.map((p) => p._id))
  const newPayments = incomingPayments.filter((p) => !existingIds.has(p._id))

  return [...basePayments, ...newPayments].sort((a, b) => {
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  })
}
